export const QUOTE_PUBLIC_CONSTANTS = Object.freeze({
    CREATE: 'QUOTE_PUBLIC__CREATE',
});

const C = QUOTE_PUBLIC_CONSTANTS;

export const QUOTE_PUBLIC_ENDPOINTS = Object.freeze({
    [C.CREATE]: '/portfolio/quotes',
});
